<template>
    <v-card class="form-container">
        <v-text-field
            v-model="newCampaign.alias"
            label="Alias"
            class="form-field"
            required
        />
        <v-text-field
            v-model="newCampaign.originator"
            label="Originator"
            :rules="[
                v => !!v || 'Field Required',
                v => (v.length >= 3) || 'Minimum 3 characters allowed',
                v => (v.length <= 11) || 'Maximum 11 characters allowed',
            ]"
            class="form-field"
            required
        />
        <label class="form-field" for="datepicker">Schedule:</label>
        <date-picker
            id="datepicker"
            v-model="newCampaign.scheduledAt"
            :disabled-date="getPastDates"
            :disabled-time="getPastTime"
            class="form-field"
            type="datetime"
        />
        <v-checkbox
            v-model="newCampaign.fallback"
            class="form-field"
            label="Check to enable SMS Fallback"
        />
        <v-text-field
            v-model="newCampaign.buttonCaption"
            label="Button Text (max 30 characters): Optional field - Mandatory for Promotional Campaigns"
            maxlength="30"
            counter="30"
            class="form-field"
            required
        />
        <v-text-field
            v-model="newCampaign.buttonUrl"
            label="Button URL: Optional field - Mandatory for Promotional Campaigns"
            class="form-field"
            required
        />
        <v-text-field
            v-model="newCampaign.imageUrl"
            label="Image URL: Optional field - Mandatory for Promotional Campaigns"
            class="form-field"
            required
        />
        <div class="form-field my-2">
            <v-slider
                v-model="newCampaign.ttl"
                :min="0"
                :max="24 * 60 * 60"
                :step="30"
                :tick-size="30"
                :label="`Time To Live ( ` + hours + `:` + minutes + `:` + remainingSeconds+ ` )`"
                class="custom-slider"
                :thumb-size="100"
                :rules="[
                    v => newCampaign.ttl > 0 || 'Time To Live cannot be zero (0)'
                ]"
            >
                <template v-slot:thumb-label>
                    {{ hours }} : {{ minutes }} : {{ remainingSeconds }} Hours
                </template>
            </v-slider>
        </div>
        <v-textarea
            v-model="newCampaign.textTemplate"
            class="form-field"
            label="Viber text template"
        />

        <v-textarea
            v-if="newCampaign.fallback"
            v-model="newCampaign.fallbackTextTemplate"
            class="form-field"
            label="Viber Fallback text template"
        />

        <v-btn
            color="primary"
            :loading="submitLoading"
            :disabled="submitLoading"
            @click="updateCampaign()"
        >
            Update
        </v-btn>
        <v-btn text @click="cancel()">
            Cancel
        </v-btn>
    </v-card>
</template>

<script>
    import { PRIVILEGES } from '@/utils/consts'
    import DatePicker from 'vue2-datepicker'
    import dateTimeUtils from '@/utils/date-time-utils'
    import 'vue2-datepicker/index.css'
    export default {
        components: { DatePicker },
        props: {
            campaign: {
                type: Object,
                default: null
            },
            submitLoading: {
                type: Boolean,
                required: true
            }
        },
        data() {
            return {
                newCampaign: {
                    alias: '',
                    originator: '',
                    fallback: '',
                    textTemplate: '',
                    fallbackTextTemplate: '',
                    scheduledAt: '',
                    buttonUrl: '',
                    buttonCaption: '',
                    imageUrl: '',
                    ttl: 0
                }
            }
        },
        computed: {
            PRIVILEGES() {
                return PRIVILEGES
            },
            hours() {
                return Math.floor(this.newCampaign.ttl / 3600)
            },
            minutes() {
                return Math.floor((this.newCampaign.ttl % 3600) / 60)
            },
            remainingSeconds() {
                return this.newCampaign.ttl % 60
            }
        },
        watch: {
            campaign(newVal) {
                this.newCampaign = newVal
                this.newCampaign.scheduledAt = new Date(newVal.scheduledAt)
            }
        },
        methods: {
            updateCampaign() {
                this.$emit('updateCampaign', this.newCampaign)
            },
            cancel() {
                this.$emit('cancel')
            },
            hasPrivilege(inputPrivilege) {
                const privileges = this.$store.getters.getCurrentUser?.privileges
                if (!privileges) {
                    return false
                }
                return !!privileges.find(({ privilege }) => privilege === inputPrivilege)
            },
            getPastDates(date) {
                return dateTimeUtils.getPastDates(date)
            },
            getPastTime(date) {
                return dateTimeUtils.getPastTime(date)
            }
        }
    }
</script>

<style scoped>

.params-container {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    column-gap: 15px;
    margin-bottom: 20px;
    gap: 10px;
}

.form-container {
    padding: 1rem;
}

.form-field {
    width: 100%;
    margin-bottom: 30px;
    padding-left: 15px !important;
    padding-right: 15px !important;
}

</style>
